import React from "react";
import InputField from "../../widgets/InputField";
import { FormProvider, SubmitHandler, useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { z } from "zod";
import { CreateOrgCredential } from "./CreateOrg";

export type CreateOrgProps = {
  onSubmit: SubmitHandler<CreateOrgCredential>;
  // isPending: boolean;
  // selectedState: string;
  // setSelectedState: (selectStateValue: string) => void;
};

const createOrgSchema = z.object({
  email: z.string().min(1, "Email is required"),
  fullName: z.string().min(1, "Name is required"),
  address: z.string().min(1, "Address is required"),
  cityName: z.string().min(1, "City name is required"),
  stateName: z.string().min(1, "State name is required"),
  pinCode: z.string().min(1, "Pin code is required"),
  orgName: z.string().min(1, "Organization Name is required"),
  gstNumber: z.string().min(1, "GST Number is required"),
  tinNumber: z.string().min(1, "TIN number is required"),
  panNumber: z.string().min(1, "PAN number is required"),
});

type CreateOrgSchema = z.infer<typeof createOrgSchema>;

function CreateOrgUi({
  onSubmit,
}: // isPending,
// selectedState,
// setSelectedState,
CreateOrgProps) {
  const default_Values = {
    email: "",
    partnerId: "",
    fullName: "",
    address: "",
    cityName: "",
    pinCode: "",
    stateName: "",
    orgName: "",
    gstNumber: "",
    orgWorkSpaceName: "",
    tinNumber: "",
    panNumber: "",
  };

  const methods = useForm<CreateOrgSchema>({
    defaultValues: default_Values,
    resolver: zodResolver(createOrgSchema),
  });

  const handleSubmit: SubmitHandler<CreateOrgCredential> = (data) => {
    onSubmit(data);
  };
  return (
    <>
      <FormProvider {...methods}>
        <form
          className="flex flex-col gap-5 w-full max-w-7xl  rounded-md py-5"
          onSubmit={methods.handleSubmit(handleSubmit)}
        >
          <div className="flex md:flex-row flex-col gap-3 w-full">
            <h3 className="w-6/12">Organization Details</h3>
            <div className=" flex flex-col gap-5 w-full">
              <div className=" grid grid-cols-1 gap-5 md:w-9/12 w-full   rounded-md   items-start ">
                <InputField
                  label="Organization Name"
                  type="text"
                  name="orgName"
                  isRequired={true}
                />

                <InputField
                  label="GST Number"
                  type="text"
                  name="gstNumber"
                  isRequired={true}
                />
                <InputField
                  label="PAN Number"
                  type="text"
                  name="panNumber"
                  isRequired={true}
                />
                <InputField
                  label="TIN Number"
                  type="text"
                  name="tinNumber"
                  isRequired={true}
                />
              </div>
            </div>
          </div>
          <div className="flex md:border-t pt-5 md:flex-row flex-col  gap-3">
            <h3 className="w-6/12">Address Details</h3>
            <div className=" flex flex-col gap-5 w-full">
              <div className=" grid grid-cols-1 gap-5 md:grid-cols-1  rounded-md md:w-9/12 w-full  items-start ">
                <InputField
                  label="Address"
                  type="text"
                  name="address"
                  isRequired={true}
                />
                {/* <ChooseStates
                  label="Select States"
                  placeHolder=""
                  name="stateName"
                  setSelectedState={setSelectedState}
                  isRequired={true}
                />

                <ChooseCities
                  label="Select City"
                  placeHolder=""
                  name="cityName"
                  selectState={selectedState}
                  isRequired={true}
                /> */}

                <InputField
                  label="Pin code"
                  type="text"
                  name="pinCode"
                  isRequired={true}
                />
              </div>
            </div>
          </div>

          <div className="flex md:border-t pt-5 md:flex-row flex-col  gap-3">
            <h3 className="w-6/12">Admin Details</h3>

            <div className=" flex flex-col gap-5 w-full">
              <div className=" grid grid-cols-1 gap-5 md:grid-cols-1 md:w-9/12 w-full rounded-md  items-start ">
                <InputField
                  label="Full Name"
                  type="text"
                  name="fullName"
                  isRequired={true}
                />
                <InputField
                  label="Email"
                  type="text"
                  name="email"
                  isRequired={true}
                />
              </div>

              <div className=" w-full  mt-5 flex gap-5 items-center  justify-start">
                <div className="w-full mt-5 flex gap-5 items-center justify-start">
                  <button
                    type="button"
                    className="w-24 py-2 px-4 text-sm font-medium text-gray-600 border border-gray-300 rounded-lg hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-400 focus:ring-offset-2 transition"
                  >
                    Cancel
                  </button>

                  <button
                    type="submit"
                    className="w-24 py-2 px-4 text-sm font-medium text-white bg-blue-600 rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition"
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
        </form>
      </FormProvider>
    </>
  );
}

export default CreateOrgUi;
